import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconToolsDiameterInnerSizeS from './IconToolsDiameterInner_size_s';

const props: CreateIconArguments = {
  l: IconToolsDiameterInnerSizeS,
  m: IconToolsDiameterInnerSizeS,
  s: IconToolsDiameterInnerSizeS,
  xs: IconToolsDiameterInnerSizeS,
  name: 'IconToolsDiameterInner',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'multiple',
};

export default props;
